const En2 = {};

export default En2;
